import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';

export const azulFluxoCaixa = '#0b2574';

export const AcessibilidadeBar = styled.div`
  border-bottom: 1px solid white;
`;

export const ContentFilledContainer = styled.div`
  min-height: calc(100vh - 210px);
  background-color: ${BaSeTheme.colors.institucionais.azulSebrae97};
  padding: 16px;
  @media screen and (max-width: ${BaSeTheme.breakpoints.tablet.maxWidth}px) {
    padding: 8px;
  }
`;

export const FullWidthDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const Flexed = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  ${({ menu }) => css`
    padding: ${menu ? '8px 0' : '0px'};
  `}
`;

export const ImageSize = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  img {
    width: 12px;
    height: 7px;
  }
`;

export const LinkLogo = styled.a`
  display: inline-block;
  text-decoration: inherit;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: scale(1.1);
  }
`;

export const WrapperFooter = styled.div`
  position: relative;
  z-index: -1;
`;

export const WrapperHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 15;
`;

export const MarginDelimitedBreakpoint = styled.div`
  .BaSe--grid-item {
    padding: 0 24px;
  }
`;

export const WrapperDesktopLogo = styled.div`
  cursor: pointer;
  width: 270px;
`;

export const WrapperMobileLogo = styled.div`
  width: 159px;
`;

export const FooterContainer = styled.div`
  .BaSe--accordion-title-container {
    display: none;
  }
`;
